import SideBarShell from "@wine2trace/ui/SideBarShell";

import logo from "@wine2trace/ui/assets/W2T_LOGO_symbol.png";

import usePermissions from "../../hooks/usePermissions";
import { useSelector } from "react-redux";
import { setItem } from "../../services/LocalStorage";
import useAuth from "../../hooks/useAuth";
import useLogout from "../../hooks/useLogout";
import { ROLES } from "../../constants/base";
import { selectImpersonationActive } from "../../context/selectors";
import { SIDEBAR_ITEMS, visibleSidebarItems } from "./sidebarItems";

// Menu entries for the shared SideBarShell, filtered by role and by the RBAC of the active winery.
const SideBar = ({ isMobile, isIcon: isIconPref, setIsIcon }) => {
  const impersonationActive = useSelector(selectImpersonationActive);
  const { can, canSee } = usePermissions();
  const logout = useLogout();
  const { auth } = useAuth();
  const role = Number(auth?.role);
  const isAdmin = role === ROLES.ADMIN;

  const handleSidebarIcons = () => {
    const newValue = !isIconPref;
    setItem("sidebar_icon", newValue);
    setIsIcon(newValue);
  };

  const visible = visibleSidebarItems(SIDEBAR_ITEMS, { isAdmin, role, can, canSee });
  const toShellItem = ({ path, labelKey, icon, activePath, exact }) => ({
    to: path,
    labelKey,
    icon,
    ...(activePath !== undefined && { activePath }),
    ...(exact !== undefined && { exact }),
  });
  const primary = visible.filter((item) => item.section === "primary").map(toShellItem);
  const secondary = visible.filter((item) => item.section === "secondary").map(toShellItem);

  return (
    <SideBarShell
      primary={primary}
      secondary={secondary}
      primaryLabelKey="primaryLinks"
      secondaryLabelKey="secondaryLinks"
      isMobile={isMobile}
      isIcon={isIconPref}
      onToggleIcons={handleSidebarIcons}
      impersonationActive={impersonationActive}
      mobileNav={{
        logo,
        // The platform ADMIN is not a client user: no profile page (null: no link in the drawer).
        profileTo: isAdmin ? null : auth?.user_id ? `/users/${auth.user_id}` : "/",
        onLogout: logout,
      }}
    />
  );
};

export default SideBar;
